import React from 'react';

export default function Grow() {
  return (
    <div className="py-20">
      <div className="container text-center mt-8 mb-6">
        <h2 className="leading-none md:leading-normal font-sans text-shop-dark-green text-4xl">
          Cool, but how does that help me grow my store?
        </h2>
      </div>

      <div className="container flex flex-row flex-wrap mb-8 justify-center">
        <p className="leading-normal text-center font-sans text-shop-dark-green mt-4 lg:w-3/4 mb-8">
          Knowing your NPS score and the feedback you receive is very
          beneficial. You can improve on the unhappy customers (or detractors)
          feedback, so you can convert them into happy customers (or promoters).
          You can spot trends of feedback, such as if a lot of customers are
          complaining about slow shipping times, you can take that feedback,
          improve your shipping times, increase your NPS, have happier
          customers, and make more sales.
        </p>
        {/* <p className="leading-normal text-center font-sans text-shop-dark-green mt-4 sm:w-2/3 mb-8">
          You can also find out what makes people super happy about your shop
          and use that feedback to keep your current customers happy and to help
          the unhappy customers turn into happy customers. Over time, after
          getting feedback and taking steps to implement changes, you should see
          your NPS number go up along with your sales.
        </p> */}
      </div>
    </div>
  );
}
